import styled from "styled-components";
import CardHeader from "./CardHeader";
import useStudentActivityPreview from "features/teacher/hooks/student/uesStudentActivityPreview";
import { hw, scrollbar } from "features/homework/homeworkUi";

interface StudentActivityPreviewProps {
    onClick: React.MouseEventHandler;
    studentUid: string;
}

const StudentActivityPreview = ({ onClick, studentUid }: StudentActivityPreviewProps) => {
    const { activityList } = useStudentActivityPreview(studentUid);

    return (
        <Container>
            <CardHeader title="활동영상" onNextClick={onClick} />
            <Wrapper>
                {activityList.length === 0 ? (
                    <Empty>등록된 활동 영상이 없습니다. 오른쪽 화살표로 영상을 추가하세요.</Empty>
                ) : (
                    activityList.map((item, index) => (
                        <Item key={index + 1}>
                            <Video src={item.video} />
                            <Title>{item.title}</Title>
                        </Item>
                    ))
                )}
            </Wrapper>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 18px 20px;
    border-radius: 16px;
    background: ${hw.surface};
    border: 1px solid ${hw.border};
    box-shadow: ${hw.shadow};
`;

const Wrapper = styled.div`
    display: flex;
    gap: 12px;
    overflow-x: auto;
    overflow-y: hidden;
    min-height: 168px;
    ${scrollbar}
`;

const Empty = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${hw.textSubtle};
    font-size: 13px;
    line-height: 1.5;
    text-align: center;
    padding: 24px;
`;

const Item = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex-shrink: 0;
    width: 220px;
`;

const Video = styled.video`
    height: 132px;
    width: 100%;
    object-fit: cover;
    border-radius: 12px;
    background: #0F172A;
    border: 1px solid ${hw.border};
`;

const Title = styled.div`
    color: ${hw.text};
    font-size: 13px;
    font-weight: 600;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export default StudentActivityPreview;
